import { combineReducers } from 'redux';
import { connectRouter, routerMiddleware } from 'connected-react-router-for-react18';
import { History } from 'history';
import { ApplicationState, reducers } from '.';
import { configureStore } from '@reduxjs/toolkit';

export default function setupStore(history: History, initialState?: ApplicationState) {
    const middleware = [
        routerMiddleware(history),
        
    ];
    const rootReducer = combineReducers({
        router: connectRouter(history),
        ...reducers
    });
    const enhancers: any = [];


    return configureStore({
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) =>
            [...getDefaultMiddleware(), ...middleware],
        enhancers: enhancers,
        preloadedState: initialState,
        devTools: process.env.NODE_ENV !== 'production'
    });
}
